// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "(max-width: 768px)";
var _4 = "loyalty__modal-3JBea";
var _5 = "switchWrapper-3MslX";
export { _1 as "__esModule", _2 as "mobile", _3 as "tabletMiddle", _4 as "loyalty__modal", _5 as "switchWrapper" }
export default { "__esModule": _1, "mobile": _2, "tabletMiddle": _3, "loyalty__modal": _4, "switchWrapper": _5 }
